import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { ScheduledRideInput } from '@/models/scheduledRide';

export const updateScheduledRide = async ({ scheduledRideId, data }: { scheduledRideId: number; data: ScheduledRideInput }) => {
  const response = await mutationExecute({
    variables: {
      scheduledRideId,
      data,
    },
    mutation: graphql(`
      mutation UpdateScheduledRide($scheduledRideId: Float!, $data: ScheduledRideInputType!) {
        updateScheduledRide(scheduledRideId: $scheduledRideId, data: $data) {
          id
        }
      }
    `),
  });

  return response.data?.updateScheduledRide;
};
